import { useState, useEffect } from 'react';
import { useSubscriptionsStore } from '../../../store/models/subscriptions';
import { usePublisherStore } from '../../../store/models/publisher';
import { useProfileStore } from '../../../store/models/profile';

function useSidebarData() {
    const subscriptionsStore = useSubscriptionsStore();
    const publisherStore = usePublisherStore();
    const profileStore = useProfileStore();

    const [quickViewItems, setQuickViewItems] = useState([]);
    const [recommendedPublishers, setRecommendedPublishers] = useState([]);
    const [keyInsight, setKeyInsight] = useState({});

    // Load recommended publishers on mount — not loaded by world page when on /manage
    useEffect(() => {
        publisherStore.getRecommendedPublishers();
    }, []);

    useEffect(() => {
        // Quick view — active subscriptions with connected schedule count
        const items = subscriptionsStore.subscriptions.map((sub) => ({
            id: sub.id,
            name: sub.publisher?.name || '',
            logo: sub.publisher?.logo || '',
            scheduleCount: (sub.subscribedSchedules || []).length,
        }));
        setQuickViewItems(items);
    }, [subscriptionsStore.observed.subscriptions]);

    useEffect(() => {
        setRecommendedPublishers(publisherStore.recommendedPublishers);
    }, [publisherStore.observed.recommendedPublishers]);

    useEffect(() => {
        setKeyInsight(profileStore.profileDisplay);
    }, [profileStore.observed.profile]);

    return {
        quickViewItems,
        recommendedPublishers,
        keyInsight,
    };
}

export default useSidebarData;
